import { homeTheme } from "~/theme/ip/home";
import { oneroomtaTheme, oneroomtaAssets } from "~/theme/ip/oneroomta";
import { seeingdoubleTheme, seeingdoubleAssets } from "~/theme/ip/seeingdouble";
import type { IpAssets, SiteTheme } from "~/theme/types";

const SITE_THEMES: Record<string, SiteTheme> = {
  home: homeTheme,
  seeingdouble: seeingdoubleTheme,
  oneroomta: oneroomtaTheme,
};

const IP_ASSETS: Record<string, IpAssets> = {
  seeingdouble: seeingdoubleAssets,
  oneroomta: oneroomtaAssets,
};

export function resolveSiteTheme(slug: string | undefined): SiteTheme {
  return (slug && SITE_THEMES[slug]) || homeTheme;
}

export function resolveIpAssets(slug: string): IpAssets {
  const assets = IP_ASSETS[slug];
  if (!assets) {
    throw new Error(`No IpAssets registered for slug: ${slug}`);
  }
  return assets;
}
